var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-table__cell-value",
      class: { "cell-rank_disabled": !_vm.canEdit },
      on: {
        click: function ($event) {
          _vm.canEdit && (_vm.isShowContainer = true)
        },
      },
    },
    [
      _vm.calculateType !== "byDate"
        ? _c("span", [_vm._v(_vm._s(_vm.rankLocalValueLabel))])
        : _vm._e(),
      _vm.calculateType == "byDate"
        ? _c("Select2", {
            staticClass: "cell-rank-select",
            attrs: {
              options: _vm.rankLocalItems,
              disabled: !_vm.canEdit,
              settings: {
                minimumResultsForSearch: Infinity,
                dropdownCssClass: "needsclick",
                selectionCssClass: "needsclick",
              },
            },
            on: {
              select: function ($event) {
                return _vm.selectRank($event)
              },
            },
            model: {
              value: _vm.rankLocalValue,
              callback: function ($$v) {
                _vm.rankLocalValue = $$v
              },
              expression: "rankLocalValue",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }